module.exports = __webpack_public_path__ + "right.svg?1976e8c2537a1dd85378e79b912c7c31";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right.svg
// module id = 86
// module chunks = 0